import React, { useEffect, useState } from 'react'
import styles from '../sass/selectaddress.module.scss'
import { Icons, IMG } from '../constant'
import NewAddressModal from './newAddress'
import EditAddressModal from './editAddress'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAddresses, removeAddress, editAddress, setUserSelectedAddress } from '../redux/actions/addressActions'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

const SelectAddressModal = ({ onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [modalVisible, setModalVisible] = useState(false);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const { token, userDetails } = useSelector((state) => state.user);
  const { addresses, loader } = useSelector((state) => state.userAddress);
  const [selectedAddress, setSelectedAddress] = useState(null); 

  const user_id = userDetails?.id;

  useEffect(() => {
    if (user_id && token) {
      dispatch(fetchAddresses(user_id));
    }
  }, [dispatch, user_id, token]);

  useEffect(() => {
    // Automatically select the first address if available
    if (addresses.length > 0) {
      setSelectedAddress(addresses[0]);
    }
  }, [addresses]);

  const handleSelectAddress = (address) => {
    setSelectedAddress(address);
  };

  const handleDeliveryHere = () => {
    if (selectedAddress) {
      dispatch(setUserSelectedAddress(selectedAddress))
        .unwrap() // Optional: To handle the resolved/rejected state manually
        .then(() => {
            navigate('/checkout');
        })
        .catch((error) => {
          console.error('Failed to set address:', error);
        });
    } else {
      toast.info('Please select an address first.');
    }
  };

  const handleRemoveAddress = (user_id, address_id) => {
    const isConfirmed = window.confirm("Are you sure you want to remove this address?");
    if (isConfirmed) {
        dispatch(removeAddress({ user_id, address_id }))
        .unwrap()
        .then(() => {
            toast.success("Address removed successfully."); // Show success alert
        })
        .catch((error) => {
            toast.error(error.message || "Failed to remove address."); // Show error alert
        });
        
    }
  };

  return (
    <>
    <div className={`modal-overlay ${styles.ModalOverlaySection}`} onClick={onClose}>
        <div className={`modal-content ${styles.ModalDrawerContainer}`} onClick={(e) => e.stopPropagation()}>
            <div className={styles.AddressOnCart_header}>
                <div>Select Address</div>
                <div className={styles.crossIcon} onClick={onClose}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18" stroke="#30363C" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path><path d="M6 6L18 18" stroke="#30363C" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </div>
            </div>
            <div className={styles.AddressOnCart_content}>
                <div className={styles.AddressOnCart_selectDeliveryAddress}>
                    <div className={styles.SelectDeliveryAddress_buttonWrapper}>
                        <button className={`Button_container Button_outlined ${styles.SelectDeliveryAddress_addNewButton}`} onClick={() => setModalVisible(true)}>Add new address</button>
                    </div>
                    {addresses.length === 0 ? (
                        <div className={styles.NoAddressFound_emptyAddressPage}>
                            <div className={styles.NoAddressFound_emptyAddressInfo}>
                                <div className={styles.NoAddressFound_header}>NO ADDRESS FOUND</div>
                                <div className={styles.NoAddressFound_subheader}>You have no address saved</div>
                            </div>
                        </div>
                    ) : (
                    <>
                        <div className={styles.SelectDeliveryAddress_addressListHeading}>Deliver To</div>
                        <div>
                            <div className={styles.SelectDeliveryAddress_addressCardsContainer}>
                            {addresses.map((address, index) => (
                                <div key={index} className={`${styles.AddressCard_addressCard} ${selectedAddress?.id === address.id ? styles.active : ''}`}>
                                    <div className={styles.AddressCard_addressCardContainer}>
                                        <div className={styles.AddressCard_addressDetailsContainer}>
                                            <div className={styles.AddressCard_addressCardHeader}>
                                                <div className={styles.AddressCard_addressTypeTitle}>{address.address_type}</div>
                                                <img alt='selection' width={16} height={16} src={selectedAddress?.id === address.id ? Icons.radioButtonEnabled : Icons.radioButtonDisabled}  onClick={() => handleSelectAddress(address)} />
                                            </div>
                                            <div>
                                                <div className={styles.AddressCard_addressDetails}>
                                                    <p className={styles.AddressCard_addName}>{address.fname} {address.lname}</p>
                                                    <p>
                                                        {address.address} <br />
                                                        {address.city}, {address.state_name} <br />
                                                        {address.country_name} - {address.pincode}.
                                                    </p>
                                                    <p>Phone: {address.phone} {address.alt_phone !== null ? ` / ${address.alt_phone}` : ''}</p>
                                                    {address.landmark && <p style={{ marginBlock: 5 }}><b>Landmark: </b> {address.landmark}</p>}
                                                    {address.gstin !== null ? <p>GSTIN: {address.gstin}</p> : null }
                                                    {address.dla !== null ? <p>Drug License: {address.dla}</p> : null }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={styles.AddressCard_actionButtonsWrapper}>
                                        <div className={styles.AddressCard_removeItemButton} onClick={() => handleRemoveAddress(user_id, address.id)}>
                                            <img alt='remove' width={24} height={24} src={Icons.icDelete} />
                                        </div>
                                        <div className={styles.AddressCard_editBtn} onClick={() => {setSelectedAddress(address); setEditModalVisible(true)}}>
                                            <span className={styles.AddressCard_pencilWrapper}>
                                                <span className={styles.AddressCard_pencil}>
                                                    <svg width="16" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.0222 2.69331C13.2256 2.4856 13.4982 2.37168 13.7794 2.37168C13.9189 2.37168 14.0574 2.39972 14.1871 2.4546C14.3169 2.50949 14.4357 2.59036 14.5366 2.69331C14.6374 2.79629 14.7181 2.91935 14.7735 3.05581C14.8288 3.19231 14.8575 3.3391 14.8575 3.48767C14.8575 3.63625 14.8288 3.78304 14.7735 3.91953C14.7181 4.056 14.6374 4.17905 14.5366 4.28204L4.19575 14.8428L2.16323 15.3618L2.67843 13.2571L13.0222 2.69331ZM13.7794 0.97168C13.1173 0.97168 12.4854 1.24042 12.0219 1.71383L1.54395 12.4147C1.45612 12.5044 1.39403 12.616 1.36418 12.738L0.52595 16.1622C0.467483 16.4011 0.538624 16.6531 0.713358 16.8261C0.888091 16.9991 1.14079 17.0678 1.37904 17.0069L4.73197 16.1509C4.85617 16.1191 4.96928 16.0539 5.05896 15.9623L15.5369 5.26151C15.7663 5.02723 15.9475 4.7499 16.0708 4.44572C16.1942 4.14156 16.2575 3.81606 16.2575 3.48767C16.2575 3.15929 16.1942 2.83379 16.0708 2.52963C15.9475 2.22545 15.7663 1.94811 15.5369 1.71383C15.3074 1.47952 15.0343 1.29286 14.7326 1.16523C14.4308 1.03758 14.1069 0.97168 13.7794 0.97168ZM8.74997 15.6287C8.36337 15.6287 8.04997 15.9421 8.04997 16.3287C8.04997 16.7153 8.36337 17.0287 8.74997 17.0287H16.2941C16.6807 17.0287 16.9941 16.7153 16.9941 16.3287C16.9941 15.9421 16.6807 15.6287 16.2941 15.6287H8.74997Z" fill="#6E787E"></path></svg>
                                                </span>
                                                <span className={styles.AddressCard_actionText}>Edit</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            </div>
                        </div>
                    </>
                    )}
                </div>

                <div className={styles.AddressOnCart_saveAndContinueWrapper}>
                    <button 
                        type={addresses.length === 0 ? "button" : "submit"}
                        disabled={addresses.length === 0 ? true : false}
                        onClick={handleDeliveryHere} 
                        style={addresses.length === 0 ? {opacity: 0.5} : {opacity: 1}}
                        className={`Button_container ${styles.AddressOnCart_buttonContinue}`}
                    >Continue</button>
                </div>
            </div>
        </div>
    </div>
    {modalVisible && <NewAddressModal onClose={onClose}/> }
    {editModalVisible && (
        <EditAddressModal
          address={selectedAddress}
          onClose={() => setEditModalVisible(false)}
        />
    )}
    </>
  )
}

export default SelectAddressModal